// Fixed geographic cells (~250 m near Glastonbury), independent of active filters.
// These are geographic bins, not cadastral MBLU boundaries.
const LAT_STEP = 0.00225;
const LNG_STEP = 0.003;
export function crimeDensityFeatures(points, weighted = false) {
  const cells = new Map();
  for (const point of points) {
    const { latitude, longitude } = point;
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude) || Math.abs(latitude) >= 85 || Math.abs(longitude) > 180) continue;
    const row = Math.floor(latitude / LAT_STEP), column = Math.floor(longitude / LNG_STEP);
    const key = `${row}:${column}`;
    const count = weighted ? Number(point.count) : 1;
    if (!Number.isFinite(count) || count <= 0) continue;
    if (!cells.has(key)) cells.set(key, { row, column, count: 0 });
    cells.get(key).count += count;
  }
  return { type: 'FeatureCollection', features: [...cells.values()].map(({ row, column, count }) => {
    const west = column * LNG_STEP, south = row * LAT_STEP;
    const east = west + LNG_STEP, north = south + LAT_STEP;
    return { type: 'Feature', properties: { count, height: count * 30 }, geometry: { type: 'Polygon', coordinates: [[[west, south], [east, south], [east, north], [west, north], [west, south]]] } };
  }) };
}
